import { render, staticRenderFns } from "./RHeaderForLogin.vue?vue&type=template&id=31179d5a&scoped=true"
var script = {}
import style0 from "./RHeaderForLogin.vue?vue&type=style&index=0&id=31179d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31179d5a",
  null
  
)

export default component.exports